import { render, staticRenderFns } from "./FormComponentConfig.vue?vue&type=template&id=7b1bc020&scoped=true"
import script from "./FormComponentConfig.vue?vue&type=script&lang=js"
export * from "./FormComponentConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1bc020",
  null
  
)

export default component.exports